import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import { AgGridReact } from "ag-grid-react";
import VisibilityIcon from "@mui/icons-material/Visibility";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "../../util/axios";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Context } from "../../component/Context/ErrorContext";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CompanyModal from "../../component/CompanyModal";

const pageSize = 10;

const Companies = () => {
  const { setError } = useContext(Context);
  const navigate = useNavigate();
  const [companyData, setCompanyData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [createUpdateModal, setCreateUpdateModal] = useState({
    action: "",
  });
  const [company, setCompany] = useState({
    id: 0,
    name: "",
    domain: "",
    contact_email: "",
    password: "",
    phone: "",
    address: "",
    latitude: "",
    longitude: "",
    total_amount: "",
    count_of_current_employee: "",
    number_of_current_employee: "",
  });
  // Column Definitions: Defines the columns to be displayed.
  const [colDefs] = useState<any>([
    {
      field: "name",
      headerName: "Name",
      minWidth: 250,
      cellRenderer: (param: any) => {
        return (
          <div
            className={"flex items-center gap-2 cursor-pointer"}
            onClick={() => navigate(`/companies/${param?.data?.id}`)}
          >
            <VisibilityIcon />
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "contact_email",
      headerName: "Email",
      minWidth: 200,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "phone",
      headerName: "MOBILE NUMBER",
      minWidth: 150,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "start_subscription",
      headerName: "DATE",
      minWidth: 100,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{moment(param.value).format("MM/DD/YYYY")}</p>
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 40,
      cellRenderer: (param: any) => {
        return (
          <div className={"h-full flex items-center gap-4"}>
            <EditIcon
              className={"text-primaryText cursor-pointer"}
              titleAccess={"Edit"}
              onClick={() => {
                setCompany(param?.data);
                setCreateUpdateModal({
                  action: "Update",
                });
              }}
            />
            <CloseIcon
              className={"text-red-600 cursor-pointer"}
              titleAccess={"Delete"}
              onClick={() => deleteCompany(param?.data?.id)}
            />
          </div>
        );
      },
    },
  ]);


  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    setLoading(true);
    axios({
      URL: `/omw/admin/get-company-subscription`,
      method: "GET",
    })
      .then((res: any) => {
        setCompanyData(res?.data?.data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const createCompanyHandler = () => {
    const payload: any = { ...company };
    if (createUpdateModal.action === "Create") {
      delete payload.id;
      payload.start_subscription = moment().format();
      payload.end_subscription = moment().add(1, "year").format();
    }else{
      if(company?.password === ''){
        delete payload.password;
      }
    }

    setModalLoading(true);
    axios(
      createUpdateModal.action === "Update"
        ? {
            URL: `/omw/admin/update-company-subscription/${company?.id}`,
            method: "PATCH",
            data: { ...payload },
          }
        : {
            URL: "/omw/admin/create-company-subscription",
            method: "POST",
            data: {
              ...payload,
            },
          }
    )
      .then((res: any) => {
        if (res.data) {
          fetchCompanyData();
          setModalLoading(false);
          setCompany({
            id: 0,
            name: "",
            domain: "",
            contact_email: "",
            password: "",
            phone: "",
            address: "",
            latitude: "",
            longitude: "",
            total_amount: "",
            count_of_current_employee: "",
            number_of_current_employee: "",
          });
          setCreateUpdateModal({ action: "" });
        }
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      })
      .finally(() => setModalLoading(false));
  };

  const deleteCompany = (id: any) => {
    axios({
      URL: `/omw/admin/delete-company-subscription/${id}`,
      method: "DELETE",
    })
      .then((res: any) => {
        if (res.data) {
          fetchCompanyData();
        }
      })
      .catch((err: any) => {
        setError(err.response?.data?.message)
      });
  };

  return (
    <ContentLayout className={"items-start"}>
      <p className={"text-3xl font-bold text-secondary"}>Companies</p>
      <div className={"mt-4 w-full h-auto bg-white p-2"}>
        <div className={"flex w-full justify-end my-3 px-3"}>
          <button
            className={
              "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full"
            }
            onClick={() =>
              setCreateUpdateModal({
                action: "Create",
              })
            }
          >
            Create Company
          </button>
        </div>
        <div className="ag-theme-quartz w-full" style={{ height: 500 }}>
          <AgGridReact
            loading={loading}
            rowData={companyData}
            defaultColDef={{
              flex: 10,
            }}
            columnDefs={colDefs}
            pagination={true}
            paginationPageSize={pageSize}
            paginationPageSizeSelector={[10, 25, 50, 100]}
          />
        </div>
      </div>
      <CompanyModal
        open={createUpdateModal.action}
        onClose={() => setCreateUpdateModal({ action: "" })}
        company={company}
        setCompany={setCompany}
        onSubmit={createCompanyHandler}
        loading={modalLoading}
      />
    </ContentLayout>
  );
};

export default Companies;
